import { render, staticRenderFns } from "./viod.vue?vue&type=template&id=d685cbfc&scoped=true"
import script from "./viod.vue?vue&type=script&lang=js"
export * from "./viod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d685cbfc",
  null
  
)

export default component.exports